<template>
  <div ref="wrapper">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';

const emit = defineEmits<{
  'observe-node-visibility': [{ visible: boolean }];
}>();

const wrapper = useTemplateRef('wrapper');

useIntersectionObserver(wrapper, ([{ isIntersecting }]) => {
  emit('observe-node-visibility', { visible: isIntersecting });
});
</script>
